module.exports = __webpack_public_path__ + "static/media/video.d38781ae.svg";